import api from "../config/api";

// Transaction listesi
export const getTransactions = async () => {
  try {
    const response = await api.get("/transactions");
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Kullanıcıya ait transaction listesi
export const getUserTransactions = async (userId) => {
  try {
    const response = await api.get(`/transactions?user_id=${userId}`);
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Tek bir transaction getirme
export const getTransactionById = async (id) => {
  try {
    const response = await api.get(`/transactions/${id}`);
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};
